<template>
  <div class="left-wrapper">
    <div class="title">
      河道列表
    </div>
    <div class="search-box">
      <el-input placeholder="请输入搜索内容" suffix-icon="el-icon-search" v-model="searchForm.name">
      </el-input>
    </div>
    <div class="plot-list">
      <!-- <YScroll style="height:100%">
        <template>
          <LBTree :treeData="treeData" :isParent="(data) => data.children">
            <template v-slot:parent="ctx">
              <div class="c-mainpage-left__tree-item" @click="ctx.row.showChildren = !ctx.row.showChildren">
                <div class="c-mainpage-left__tree-item-name">
                  {{ ctx.row.name + '('
                  }}<span class="num">{{ ' ' + ctx.row.children.length + ' ' }}</span>)
                </div>
                <div class="c-mainpage-left__tree-item-icon c-mainpage-left__tree-item-icon--light">
                  <i :style="{
                      transform: ctx.row.showChildren
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                  }" class="el-icon-arrow-down"></i>
                </div>
              </div>
            </template>
            <template v-slot:children="ctx">
              <div @click="toDetailView(ctx.row, '1')" class="c-mainpage-left__tree-item is-sub" :class="{
                  'c-mainpage-left__tree-item--color1': ctx.row.taskStatus === '2',
                  'c-mainpage-left__tree-item--color2': ctx.row.taskStatus === '1',
              }">
                <div class="c-mainpage-left__tree-item-name tree_name" :title="ctx.row.name">
                  <img :src="require('../imgs/item.png')" alt="" />
                  {{ ctx.row.name }}
                </div>
                <div class="c-mainpage-left__tree-item-icon ">
                  {{ ctx.row.taskStatus === '1' ? '有异常' : '正常' }}
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </template>
          </LBTree>
        </template>
      </YScroll> -->
      <CustomTree :data="treeData" :props="{ label: 'name' }" :highlight-current="false" @node-click="treeNodeClick">
      </CustomTree>
    </div>
  </div>
</template>

<script>

// import LBTree from '../../mainPage/components/LBTree.vue';
import { TreeUtil, tool } from '@Util';
import * as Api from './Api';
import CustomTree from '@/page/jiwei/components/CustomTree/CustomTree';

export default {
    data () {
        return {
            searchForm: {
                name: '',
            },

            organList: [], // 机构列表
            waterList: [], // 河道列表
        };
    },
    components: {

        // LBTree,
        CustomTree,
    },
    props: {
        onWaterList: {
            type: Function,
            default: null,
        },
    },
    computed: {
        treeData () {
            let organList = tool.deepCopy(this.organList);
            let waterList = this.waterList;

            let displayOrganList = TreeUtil.displayTree(organList);

            displayOrganList.forEach((item, index) => {
                let children = waterList.filter((pItem) => pItem.organId === item.id);
                let obj = item;
                obj.nodeType = 'folder';
                obj.name = item.text;
                if (obj.children) {
                    obj.children = obj.children.concat(children);
                } else {
                    obj.children = children;
                }
            });

            return organList;
        },
    },
    methods: {
    // 获取机构列表
        getOrganList () {
            let list = [];
            Api.fetchOrganTree()
                .run()
                .then((res) => {
                    this.organList = res;
                });
        },
        // 获取河道列表
        getWaterList () {
            let list = [];
            let params = this.searchForm;
            Api.fetchWaterList(params).run().then((res) => {
                list = res || [];
                this.waterList = list;
                if (typeof this.onWaterList === 'function') {
                    this.onWaterList(list);
                }
            });
        },

        treeNodeClick (data, node) {
            this.$emit('treeChildreClick', data);
        },
    },
    mounted () {
        this.getOrganList();
        this.getWaterList();
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.left-wrapper {
  .title {
    padding-top: 11px;
    text-align: center;
    font-size: 16px;
    background-image: url(../imgs/titlebg01.png);
    height: 37px;
  }

  .search-box {
    padding: 0 16px;
    padding-top: 11px;
  }

  ::v-deep .el-input__inner {
    border-color: #1A47A4;
    background-color: transparent;
  }

  .plot-list {
    margin-top: 11px;
    padding: 0 16px;
    height: 630px;
  }

  @include b(mainpage-left, c) {
    @include e(tree-item) {
      display: flex;
      justify-content: space-between;
      height: 30px;
      line-height: 30px;
      color: white;
      cursor: pointer;
      margin-bottom: 8px;

      @include when(sub) {
        padding-left: 5px;
      }

      @include m(color1) {
        background-image: linear-gradient(90deg,
            hsla(160, 65%, 61%, 60%) 0%,
            hsla(160, 65%, 61%, 30%) 30%,
            hsla(160, 65%, 61%, 30%) 70%,
            hsla(160, 65%, 61%, 60%));
        border: 1px solid hsla(160, 65%, 61%, 100%);
        border-left-width: 5px;
        vertical-align: middle;
      }

      @include m(color2) {
        background-image: linear-gradient(90deg,
            hsla(209, 100%, 51%, 60%) 0%,
            hsla(209, 100%, 51%, 30%) 30%,
            hsla(209, 100%, 51%, 30%) 70%,
            hsla(209, 100%, 51%, 60%));
        border: 1px solid hsl(209, 100%, 51%);
        border-left-width: 5px;
      }

      @include m(colorerror) {
        background-image: linear-gradient(90deg,
            hsla(339, 73%, 47%, 60%) 0%,
            hsla(339, 73%, 47%, 30%) 30%,
            hsla(339, 73%, 47%, 40%) 70%,
            hsla(339, 73%, 47%, 60%));
        border: 1px solid hsl(339, 73%, 47%);
        border-left-width: 5px;
      }

      @include m(colordisable) {
        background-image: linear-gradient(90deg,
            hsla(218, 31%, 48%, 60%) 0%,
            hsla(218, 31%, 48%, 30%) 30%,
            hsla(218, 31%, 48%, 30%) 70%,
            hsla(218, 31%, 48%, 60%));
        border: 1px solid hsl(218, 31%, 48%);
        border-left-width: 5px;
      }

      @include m(color3) {
        background-image: linear-gradient(90deg,
            hsla(218, 31%, 48%, 60%) 0%,
            hsla(218, 31%, 48%, 30%) 30%,
            hsla(218, 31%, 48%, 30%) 70%,
            hsla(218, 31%, 48%, 60%));
        border: 1px solid hsl(218, 31%, 48%);
        border-left-width: 5px;
      }

      @include e(tree-item-name) {
        vertical-align: middle;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        // width: 100px;
        .num {
          color: hsl(184, 97%, 64%);
        }

        img {
          vertical-align: middle;
        }
      }

      .tree_name {
        width: 164px;
      }

      @include e(tree-item-icon) {
        @include m(light) {
          color: hsl(184, 98%, 64%);
        }
      }
    }
  }
}
</style>
